export const getDistributor = (id, distributors) => {
    if (!distributors || !distributors.length) {
        return null;
    }
    for(let i = 0; i < distributors.length; i++) {
        if(id === distributors[i]._id) {
            return distributors[i];
        }
    }
    return null;
};